module.exports = __webpack_public_path__ + "img/icon-nav-icon-selected.6a50c48d.svg";